import {
    ContractStateChangeMessage,
    IContractStateChangeMessage
} from './socket-messages/contract-state-change-message';
import { Guid } from 'guid-typescript';

interface IHeaderNotification {
    notificationId: Guid;
    label: string;
    topic: HeaderNotificationTopic;
    innerMessage: ContractStateChangeMessage;
}
export enum HeaderNotificationTopic {
    Contract = 'CONTRACT'
}

export class HeaderNotification implements IHeaderNotification {
    notificationId: Guid;
    innerMessage: ContractStateChangeMessage;
    label: string;
    topic: HeaderNotificationTopic;
    read: boolean = false;

    constructor(
        innerMessage: ContractStateChangeMessage,
        label: string,
        topic: HeaderNotificationTopic
    ) {
        this.notificationId = Guid.create();
        this.innerMessage = innerMessage;
        this.label = label;
        this.topic = topic;
    }

    static fromContractStateChangeMessage(
        message: IContractStateChangeMessage
    ): HeaderNotification {
        return new HeaderNotification(
            ContractStateChangeMessage.fromContractStateChangeMessage(message),
            `Nuova fase contratto ${message.contractId}`,
            HeaderNotificationTopic.Contract
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/header-notification.ts